import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Row, Table } from "react-bootstrap";
import ReactPlayer from "react-player";

import LiveCards from "../../Cards/LiveCards";

import footballVideo from "../../../asset/video/football.mp4";
import livelogo from "../../../asset/svg/livelogo.svg";
import secondTeamLogo from "../../../asset/svg/secondteamlogo.svg";
import playIcon from "../../../asset/svg/play.svg";
import ModalVideoPlay from "../ModalVideoPlay";
import { FaCirclePause, FaCirclePlay } from "react-icons/fa6";
import { getLiveOdds } from "../../actions/gameSettings";
import Loader from "../Loader";

const LiveContent = () => {
  const [show, setShow] = useState(false);
  const [team, setTeam] = useState("");
  const [liveOdds, setliveOdds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const requestIdRef = useRef(0);

  const handleClose = () => setShow(false);


  const handleShow = (team) => {
    setShow(true);
    setTeam(team);
  };

  useEffect(() => {
    fetchLiveOdds();
  }, []);

  const filteredLiveOdds = liveOdds.filter((game) => {
    if (!game || game.completed === true) {
      return false;
    }

    const market = game.bookmakers?.[0]?.markets?.find((item) => item.key === "h2h");
    return Boolean(game.home_team && game.away_team && market);
  });

  const fetchLiveOdds = async () => {
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;
    setLoading(true);
    try {
      const { result } = await getLiveOdds();
      if (requestId !== requestIdRef.current) {
        return;
      }
      if (Array.isArray(result)) {
        setliveOdds(result);
      } else if (result) {
        setliveOdds([result]);
      } else {
        setliveOdds([]);
      }
    } catch (err) {
      if (requestId !== requestIdRef.current) {
        return;
      }
      setliveOdds([]);
      console.log("fetchLiveOdds err", err);
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  };

  return (
    <div className="mt-5">
      <p className="p_sm_tle">
        Live <span className="p_sm_gray">Matches</span>
      </p>

      <Row>
        <Col xs={12} xxl={6}>
          <div className="custom_react_player">
            <ReactPlayer
              url={footballVideo}
              playing={true}
              loop={true}
              controls={true}
            />
          </div>
        </Col>
        <Col xs={12} xxl={6}>
          <div>
            <LiveCards />
          </div>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col xs={12} xl={6}>
          <Card className="custom_card ">
            <Card.Body className="px-0">
              <div className="px-3 card_tle_holder">
                <p className="p_md_tle mb-0">2023 NFL Schedule</p>
                <p className="p_sm_lgt_gray mb-2">Monday, December 23</p>
              </div>

              <div>
                {loading ? (
                  <Loader />
                ) : fetchError ? (
                  <p className="text-danger px-3 mb-0 small">{fetchError}</p>
                ) : filteredLiveOdds.length === 0 ? (
                  <p className="text-muted px-3 mb-0 small">
                    No live lines available right now.
                  </p>
                ) : (
                  <Table responsive className="live_table">
                      <tbody>
                        {filteredLiveOdds.map((game, idx) => {
                          const market = game.bookmakers?.[0]?.markets?.find(m => m.key === "h2h");
                          const homeOdds = market?.outcomes?.find(o => o.name === game.home_team)?.price;
                          const awayOdds = market?.outcomes?.find(o => o.name === game.away_team)?.price;
                          return (
                            <tr key={game.id || idx}>
                              <td>
                                <div className="d-flex align-items-center gap-3">
                                  <div className="logo_bg_cle d-flex align-items-center justify-content-center">
                                    <img src={livelogo} alt="logo" />
                                  </div>
                                  <div>
                                    <p className="p_xs_gray_lft mb-0">{game.sport_title}</p>
                                    <h6 className="text-uppercase mb-0">{game.home_team}</h6>
                                  </div>
                                  {homeOdds !== undefined && (
                                    <div className="cnt_br_lft position-relative">
                                      <p className="mb-0 p_md_white ps-3">{homeOdds > 0 ? "+" : ""}{homeOdds}</p>
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className="text-center align-middle">
                                <div className="d-flex justify-content-center align-items-center h-100 w-100">
                                  <button className="final_btn">LIVE</button>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center gap-3">
                                  {awayOdds !== undefined && (
                                    <div className="position-relative cnt_br_rgt">
                                      <p className="mb-0 p_md_white pe-3">{awayOdds > 0 ? "+" : ""}{awayOdds}</p>
                                    </div>
                                  )}
                                  <div className="position-relative">
                                    <h6 className="text-uppercase mb-0">{game.away_team}</h6>
                                  </div>
                                  <div className="logo_bg_cle d-flex align-items-center justify-content-center">
                                    <img src={secondTeamLogo} alt="logo" />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center gap-3">
                                  <div className="logo_bg_cle ply_icn d-flex align-items-center justify-content-center">
                                    <img src={playIcon} alt="logo" />
                                  </div>
                                  <p className="mb-0">{game.bookmakers?.[0]?.title || ""}</p>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} xl={6} className="mt-4 mt-xl-0">
          <div>
            <p className="p_md_tle mb-0">2023 NFL Schedule</p>
            <Row className="mt-3">
              <Col md={6} xl={12} xxl={6}>
                <div className="custom_react_player_right">
                  {" "}
                  <ReactPlayer
                    url={footballVideo}
                    // playing={true}
                    // loop={true}
                    // controls={true}
                  />
                  <div className="team_section">
                    <p className="name mb-0">Barcelona</p>
                    <p className="date mb-0">03 match</p>
                  </div>
                  <div
                    className="play_pause_btn_modal"
                    onClick={() => handleShow("Barcelona")}
                  >
                    <Button className="d-flex justify-content-center align-items-center">
                      <div className="cus_h">
                        <FaCirclePlay
                          className="play_pause_icon me-2"
                          size={13}
                        />
                        <span className="play_pause_txt">Play Now</span>
                      </div>
                    </Button>
                  </div>
                </div>
              </Col>
              <Col
                md={6}
                xl={12}
                xxl={6}
                className="mt-4 mt-md-0 mt-xl-4 mt-xxl-0"
              >
                <div className="custom_react_player_right">
                  {" "}
                  <ReactPlayer
                    url={footballVideo}
                    // playing={true}
                    // loop={true}
                    // controls={true}
                  />
                  <div className="team_section">
                    <p className="name mb-0">Real Madrid</p>
                    <p className="date mb-0">10 match</p>
                  </div>
                  <div
                    className="play_pause_btn_modal"
                    onClick={() => handleShow("Real Madrid")}
                  >
                    <Button className="d-flex justify-content-center align-items-center">
                      <div className="cus_h">
                        <FaCirclePlay
                          className="play_pause_icon me-2"
                          size={13}
                        />
                        <span className="play_pause_txt">Play Now</span>
                      </div>
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <ModalVideoPlay show={show} handleClose={handleClose} team={team} />
    </div>
  );
};

export default LiveContent;
